import { useEffect } from 'react';
import * as gtag from '@/common/utils/gtags.client';

// This is also the return type of GET /api/external/v1/metadata/attribution
export type AttributionInformation = {
  fbclid?: string;
  fb_date?: number;
  ttclid?: string;
  gclid?: string;
};

export function useGTMAttribution(attribution_data?: AttributionInformation) {
  const { fbclid, fb_date, ttclid, gclid } = attribution_data || {};

  useEffect(() => {
    if ((fbclid && fb_date) || ttclid || gclid) {
      gtag.pushData({
        ...(fbclid && fb_date && { fbclid, fb_date }),
        ...(ttclid && { ttclid }),
        ...(gclid && { gclid }),
      });
    } else {
      const localFBC = localStorage.getItem('flexcar_fb_click');
      const localFBDate = parseInt(localStorage.getItem('flexcar_fb_click_time') || '');
      const localTTC = localStorage.getItem('flexcar_tt_click');
      const localGC = localStorage.getItem('flexcar_g_click');

      gtag.pushData({
        ...(localFBC && localFBDate && { fbclid: localFBC, fb_date: localFBDate }),
        ...(localTTC && { ttclid: localTTC }),
        ...(localGC && { gclid: localGC }),
      });
    }
  }, [ttclid, fbclid, fb_date, gclid]);
}
